import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { WorkshopService } from '../services/workshop-service';
import { DatePickerModule } from 'primeng/datepicker';
import { ToastService } from '../services/toast-service';
@Component({
  selector: 'app-workshop',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DatePickerModule],
  templateUrl: './workshop.html',
  styleUrl: './workshop.css',
  providers: [WorkshopService]
})
export class Workshop {
  form!: FormGroup;
  constructor(private fb: FormBuilder, private router: Router, private toast: ToastService, private workshopService: WorkshopService) { }

  ngOnInit() {
    this.form = this.fb.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]],
      online: [false],
      offline: [false],
      workshopLink: ['', Validators.pattern(
        /^(https?:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/
      )],
      location: [''],
      seats: [0, [Validators.required]],
      price: [0, [Validators.required]],
      oldPrice: [0, [Validators.required]],
      date: [null, [Validators.required, this.rangeValidator]],
      timeFrom: [null, [Validators.required]],
      timeTo: [null, [Validators.required]],
    })

    this.form.get('offline')?.valueChanges.subscribe((value) => {
      if (value == true) {
        this.form.get('location')?.addValidators(Validators.required);
      } else {
        this.form.get('location')?.clearValidators();
      }
      this.form.get('location')?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    })

    this.form.get('online')?.valueChanges.subscribe((value) => {
      if (value == true) {
        this.form.get('workshopLink')?.addValidators(Validators.required);
      } else {
        this.form.get('workshopLink')?.clearValidators();
      }
      this.form.get('workshopLink')?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    })
  }

  rangeValidator(control: any) {
    const value = control.value;

    if (!value || !value[0] || !value[1]) {
      return { rangeIncomplete: true };
    }

    return null;
  }

  cancel() {
    this.form.reset();
  }

  async submit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const formValues = this.form.value;
      if (formValues.online == false && formValues.offline == false) {
        this.toast.showError("At least one workshop format is required")
        return;
      }
      console.log(formValues)

      try {
        await this.workshopService.createWorkshop(formValues);
        this.toast.showSuccess("Workshop created successfully");
        this.form.reset();
      } catch (error) {
        console.error(error);
        this.toast.showError("Something went wrong");
      }
    }
  }

}
